import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export const participationConfig: PageConfig[] = [
  {
    name: "participation",
    title: "Participation and Engagement",
    questions: [
      {
        type: "text",
        name: "participants",
        title: "How many people participated in your initiative?",
        placeHolder: "Tokohia?",
        isRequired: true,
      },
      {
        type: "comment",
        name: "participantFeedback",
        title: `
          Please share any feedback or stories from participants.
          Outline how you achieved the goals and outcomes of your initiative?
          What impact did your initiative have on Rangitāne whānau?
        `,
        placeHolder: "Hakahoki kōrero",
      },
    ],
  },
];
